import { ScoredExperimentLoans } from '@appTypes/LoansApi.interface'
import { FeatureFlag } from '@appTypes/PagesApi.interface'

type FeatureOptionsTypes =
    | ScoredExperimentLoans['variant'][]
    | ('true' | 'false')[]
    | 'v1'[]
    | ('v1' | 'control')[]
    | ('control' | 'variant_b')[]

export const FEATURE_FLAGS: FeatureFlag = {
    experiment_testthis: 'v1',
    testthis: false,
    experiment_useMatchFactorRankingLoans: 'control',
    acquisitionJourneyEnableDatalayer: false,
    experiment_scoredCardRepaymentHeader: 'control',
}

export const FEATURE_FLAG_OPTIONS: Record<
    keyof FeatureFlag,
    FeatureOptionsTypes
> = {
    experiment_testthis: ['v1'],
    testthis: ['true', 'false'],
    experiment_useMatchFactorRankingLoans: [
        'control',
        'loan_ranking_productrecommender',
        'loan_ranking_hierarchical',
    ],
    acquisitionJourneyEnableDatalayer: ['true', 'false'],
    experiment_scoredCardRepaymentHeader: ['control', 'variant_b'],
}
